import { Icon } from '@iconify/react'
import clsx from 'clsx'
import { FC, useState } from 'react'

import s from './CompanyLogo.module.css'

export const CompanyLogo: FC<{
  companyName?: string | null
  className?: string
  fallbackClassName?: string
}> = ({ companyName, className, fallbackClassName }) => {
  const [isClearBitError, setIsClearBitError] = useState(!companyName?.length)

  return !isClearBitError ? (
    <img
      src={`https://logo.clearbit.com/${companyName}`}
      alt="logo"
      height={30}
      width={30}
      className={clsx(s.logo, className)}
      onError={() => setIsClearBitError(true)}
    />
  ) : (
    <Icon
      icon="ion:globe-outline"
      className={clsx(s.fallback, fallbackClassName, className)}
      width={24}
    />
  )
}
